import { render, staticRenderFns } from "./KnInventoryMovementReasons.vue?vue&type=template&id=669a52b9"
import script from "./KnInventoryMovementReasons.js?vue&type=script&lang=js&external"
export * from "./KnInventoryMovementReasons.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports